module.exports = __webpack_public_path__ + "static/Showreel-503117f3fb1da5601c6cd494ffc4e997.mp4";